// extracted by mini-css-extract-plugin
export default {"container":"chart_container__5buSr","countdown":"chart_countdown__eyAfL","value":"chart_value__hScce"};